
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/philosophy",
      function () {
        return require("private-next-pages/en/company/philosophy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/company/philosophy"])
      });
    }
  